<div class="demo-scroll-container">
    <upp-scrollable [scrollbar]="'y'">
        <div class="demo-content">
            <h2>User Profile</h2>
            <p class="demo-description">Edit user details using <code>upp-input</code> with different types and validation.</p>

            <div class="demo-controls">
    <ion-button size="small" (click)="toggleReadonly()">Readonly: {{ isReadonly }}</ion-button>
    <ion-button size="small" (click)="toggleDisabled()">Disabled: {{ isDisabled }}</ion-button>
    <ion-button size="small" color="warning" (click)="validate()">Validate</ion-button>
    <ion-button size="small" color="medium" (click)="resetForm()">Reset</ion-button>
</div>
            <p class="demo-hint">Validation errors appear when the field is touched (blur) or dirty. Leave required fields empty and blur to see errors.</p>

<div class="demo-section" [formGroup]="form">
    <h3>Personal Information</h3>

    <ion-list lines="none">
        <ion-item>
            <upp-input
                formControlName="name"
                placeholder="John Doe"
                title="Full Name (required, min 3 chars)"
                [readonly]="isReadonly"
                [kiosk]="false"
                [errornfo]="errorMessages">
            </upp-input>
        </ion-item>

        <ion-item>
            <upp-input
                formControlName="email"
                placeholder="john@company.com"
                title="Email (required)"
                type="email"
                [readonly]="isReadonly"
                [kiosk]="false"
                [errornfo]="errorMessages">
            </upp-input>
        </ion-item>

        <ion-item>
            <upp-input
                formControlName="phone"
                placeholder="612345678"
                title="Phone"
                type="number"
                [readonly]="isReadonly"
                [kiosk]="false">
            </upp-input>
        </ion-item>
    </ion-list>

    <h3>Compensation</h3>

    <ion-list lines="none">
        <ion-item>
            <upp-input
                formControlName="rate"
                placeholder="0.00"
                title="Hourly Rate (currency format)"
                type="price"
                [readonly]="isReadonly"
                [kiosk]="false">
            </upp-input>
        </ion-item>
    </ion-list>

    <h3>Security</h3>

    <ion-list lines="none">
        <ion-item>
            <upp-input
                formControlName="pin"
                placeholder="****"
                title="PIN"
                type="password"
                [readonly]="isReadonly"
                [kiosk]="false">
            </upp-input>
        </ion-item>
    </ion-list>
</div>
        </div>
    </upp-scrollable>
</div>
